module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.loading) ? _c('loading') : (!_vm.submissions) ? _c('div', [_vm._v("\n        Nog geen reflectie beschikbaar.\n    ")]) : _c('div', [_c('h2', [_vm._v("Dit heeft een klasgenoot gemaakt:")]), (_vm.type === 'Upload') ? [_c('upload', {
    attrs: {
      "submissions": _vm.submissions
    }
  })] : _vm._l((_vm.submissions), function(submission) {
    return _c('question', {
      key: submission.id,
      attrs: {
        "submissions": [submission]
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035bd23a","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/ReflectionPartial.vue
// module id = mXd4
// module chunks = 0 1